export const getFormattedBillingAddress = (address: any) => {
  let FormatAddress = [
    address?.companyName,
    address?.line1,
    address?.line2,
    address?.line3,
    address?.line4,
    address?.city,
    `${address?.state} ${address?.postalCode}`,
  ];
  FormatAddress = FormatAddress?.map((x) => (x ? x?.trimEnd() : x))?.filter(
    (x) => x !== '' && x !== null
  );
  return FormatAddress.join(', ');
};
